import { render, staticRenderFns } from "./Ooooor.vue?vue&type=template&id=309f7f4a&"
import script from "./Ooooor.vue?vue&type=script&lang=js&"
export * from "./Ooooor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports